import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1 pb-100">
      <div className="container">
        <div className="info">
          <h1 className="js-title"> Contact </h1>
          <div className="text fsz-18 color-666">
            {/* Want to chat further? We’d love to hear from you, let us opportunity{' '}
            <br /> to make your dream become reality{' '} */}
            Want to chat further ? We’d love to hear from you. 
            <h3>Contact Us : +91-9527638317</h3>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
